export default __webpack_public_path__ + "static/media/Level32.7796ce1c.svg";